var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.277,
    viewBox: "0 0 20 13.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_Icon",
    "data-name": "View Icon",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M.125,7.055a.754.754,0,0,1,0-.83C.292,5.976,3.777,0,10,0s9.707,5.976,9.874,6.225a.75.75,0,0,1,0,.83c-.167.248-3.652,6.222-9.874,6.222S.292,7.3.125,7.055ZM1.867,6.64C2.7,7.886,5.6,11.619,10,11.619s7.3-3.733,8.131-4.979C17.3,5.394,14.4,1.661,10,1.661S2.7,5.394,1.867,6.64Zm4.747,0A3.385,3.385,0,1,1,10,10,3.381,3.381,0,0,1,6.614,6.64Zm1.694,0A1.692,1.692,0,1,0,10,4.96,1.69,1.69,0,0,0,8.308,6.64Z",
    fill: "#474b4f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/View_Icon.e7139a5fb0afedf6214dfa3739030a1f.svg";
export { ForwardRef as ReactComponent };